
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutationById from "./helper/useUpdateMutationById";

  const API = {
    GET: "/api/admin/static_info",
    ADD: "/api/admin/static_info",
    UPDATE: "/api/admin/static_info",
    DELETE: "/api/admin/static_info",
  };

  const KEY = "STATIC_INFO";
  export const useGetStaticInfo = (params?:any) => useGetQuery(KEY, API.GET, params);
  export const useAddStaticInfo = () => useAddMutation(KEY, API.ADD);
  export const useUpdateStaticInfo = () => useUpdateMutationById(KEY, API.UPDATE);
  export const useDeleteStaticInfo = () =>useDeleteMutation(KEY, API.DELETE);
